import { render, staticRenderFns } from "./Source.vue?vue&type=template&id=5ed2a976&"
import script from "./Source.vue?vue&type=script&lang=js&"
export * from "./Source.vue?vue&type=script&lang=js&"
import style0 from "./Source.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports